import type { FaireProductEntity } from "../../entity_types/product";

export const p_4g7p74ybha: FaireProductEntity = {
  token: "p_4g7p74ybha",
  type: "product",
  name: "Lavender Vanilla Earl Grey - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/9c470ce17a1891386a8c1b1798d3d6af9b55b5935b4573465442697a63ca870c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f8618bf8c9ad541d817b9258cf61d8d287af6c558767f0ea0f44bff56bf78171.png"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND\n\nBold black tea, soothing floral lavender, and a creamy finish from vanilla bean…would you like a buttered scone with that? This chic twist on a classic Earl Grey sips like a dream, and will transport you to tea time with royalty (from the comfort of your couch). Serve it straight up, or steep it strong and top with frothed milk for a luxe lavender London fog. \n\n100% ORGANIC - NUTRITIONIST FORMULATED - SUGAR FREE \n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Make a Lavender Vanilla London Fog: Steep 2 teaspoons of tea with 3/4 cup of boiling water for 5 minutes. Sweeten to taste and top with 3/4 cup frothed milk.\n\n * Ice it: Steep it double strength and top with plenty of ice. Great with oat milk. \n * Cold-brew: Brew it overnight with cold water and add milk and honey. \nWhen to Steep:\n\n\n * As your morning pick-me-up \n * As a healthy coffee substitute \n * An afternoon treat \n * As a part of a brunch or high tea party! \nModerate Caffeine\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:39.002Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
